/*eslint no-unused-vars: [0]*/
import { put, select, call, all } from "redux-saga/effects";
import moment from 'moment';
import api from './../api';
import {
	fetchProductsSuccess,
	fetchProductCategoriesSuccess,
	updateOrder,
	updateOrderSuccess,
	updateOrderFail,
	clearCart,
	userFetchFail,
	fetchProductSuccess,
	fetchProductBundlesSuccess,
	checkoutSuccess,
	setOrderRowsMeta,
	toastrAdd
} from "../actions";

import { getSearchTerm, getUser, getEvent, getCart, orderRowsMetaLoaded, getPartnerPortalSettings, getPartner } from '../selectors';

export function* fetchProductsSaga(action) {
	const event = yield select(getEvent);

	try {
		const searchTerm = yield select(getSearchTerm);
		const eventID = yield event.eventID ? event.eventID : localStorage.getItem("eventID");
		const response = yield api.shop.getProducts(eventID, {
			params: {
				"search[0][column]": "name",
				"search[0][values][0]": searchTerm
			}
		});
		yield put(fetchProductsSuccess(response.data.data.products, response.data.meta));
	} catch (error) {
		let errorMessage = "Käyttäjätietojen nouto epäonnistui.";
		yield put(userFetchFail(errorMessage));
	}
}

export function* fetchProductCategoriesSaga(action) {
	const event = yield select(getEvent);
	try {
		const eventID = yield event.eventID ? event.eventID : localStorage.getItem("eventID");
		const response = yield api.shop.getProductCategories(eventID);
		yield put(fetchProductCategoriesSuccess(response.data.data.productCategories));
	} catch (error) {
		yield put(toastrAdd({ details: 'Could not get product categories', title: 'Error', type: 'error' }));
	}
}

export function* fetchProductSaga(action) {
	const productID = yield action.productID;
	try {
		const response = yield api.shop.getProduct(productID);
		yield put(fetchProductSuccess(response.data.data.product));
	} catch (error) {
		yield put(toastrAdd({ details: 'Could not get product', title: 'Error', type: 'error' }));
	}
}

export function* fetchProductBundlesSaga() {
	try {
		const response = yield api.shop.getProductBundles();
		yield put(fetchProductBundlesSuccess(response.data.data.productBundles));
	} catch (error) {
		yield put(toastrAdd({ details: 'Could not get product bundles', title: 'Error', type: 'error' }));
	}
}


export function* fetchCartSaga(action) {
	const eventID = yield action.eventID;
	let orderID = yield localStorage.getItem("orderID") ? localStorage.getItem("orderID") : null;
	const partnerPortalSettings = yield select(getPartnerPortalSettings);
	const orderRowsMetaIsLoaded = yield select(orderRowsMetaLoaded);
	if(!orderRowsMetaIsLoaded) {
		try {
			const response = yield api.shop.getOrderRowsMeta();
			yield put(setOrderRowsMeta(response.data.data.meta));
		} catch (error) {
			yield put(toastrAdd({ details: 'Could not get order rows meta', title: 'Error', type: 'error' }));
		}
	}
	/*
	* Check if user has orderID in localStorage, fetch that order.
	* If the fetched order is related to selected event, use it.
	*/
	try {

		let order = null;

		// Check for order from localStorage
		if ( orderID ) {
			const response = yield api.shop.getOrder(orderID);
			if( response.status === 200 && response.data.data.order ) {
				if(response.data.data.order.eventID === eventID) {
					order = yield response.data.data.order;
					yield localStorage.setItem("orderID", order.orderID);
					yield put(updateOrderSuccess({orderID: order.orderID, order: order}));
				} else {
					yield put(clearCart());
				}
			} else {
				yield localStorage.removeItem("orderID");
			}
		}

		// Check all event orders
		if( !order ) {
			const response = yield api.shop.getOrders(eventID);
			const orders = yield response.data.data.orders;
			if (partnerPortalSettings && partnerPortalSettings.userCanEditOrders) {
				order = yield response.data.data.orders[0];
				yield localStorage.setItem("orderID", order.orderID);
				yield put(updateOrderSuccess({orderID: order.orderID, order: order}));
			} else {
				for(let i = 0; i < orders.length; i++){
					if(response.data.data.orders[i].eventID === eventID && response.data.data.orders[i].status === 9) {
						order = yield response.data.data.orders[i];
						yield localStorage.setItem("orderID", order.orderID);
						yield put(updateOrderSuccess({orderID: order.orderID, order: order}));
						break;
					}
				}
			}
		}
		// If order still cannot be retrieved, clear localStorage
		if(!order) {
			yield localStorage.removeItem("orderID");
		}

	} catch (error) {
		// TODO
		yield localStorage.removeItem("orderID");
	}

}

export function* setQuantitySaga(action) {
	const cart = yield select(getCart);
	let order = {...cart.order};

	yield order.orderRows.map(orderRow => {
		if(orderRow.productID === action.productID && orderRow.orderRowID === action.orderRowID) {
			orderRow.productCount = action.quantity;
		}
		return orderRow
	});

	try {
		yield put(updateOrder(order));
	} catch (error) {
		// Can't create an order
	}
}

export function* addToCartSaga(action) {
	const product = yield action.product;
	const currentOrder = yield select(getCart);
	const orderID = yield currentOrder.orderID;
	const partnerPortalSettings = action.partnerPortalSettings;
	const user = yield select(getUser);
	
	let isNewProduct = yield true;
	let updatedOrder = yield {
		status: (partnerPortalSettings && partnerPortalSettings.userCanEditOrders) ? currentOrder.order.status : 9,
		orderRows: currentOrder.order.orderRows ? [...currentOrder.order.orderRows]  : [],
		partnerID: localStorage.getItem("partnerID")
	};

	// Update productCount of a existing product
	if( updatedOrder.orderRows.length > 0 ) {
		yield updatedOrder.orderRows.map(orderRow => {
			if(orderRow.productID === product.productID && orderRow.status === 5) {
				if (product.stock) {
					if (product.stock > orderRow.productCount) {
						orderRow.productCount ++;
					}
					isNewProduct = false;
				} else {
					orderRow.productCount ++;
					isNewProduct = false;
				}
			}
			return orderRow;
		});
	}

	// Add new product
	if(isNewProduct) {
		yield updatedOrder.orderRows.push({
			orderID: orderID,
			productID: product.productID,
			price: product.price,
			name: product.name,
			description: product.description,
			originalPrice: product.price,
			taxPercent: product.taxPercent,
			productCount: (product.quantity || 1),
			product: product
		});
	}
	yield put(updateOrder(updatedOrder, false, action.eventID));
}


export function* removeProductFromCartSaga(action) {
	const orderRowID = yield action.orderRowID;
	var cart = yield {...select(getCart)};
	cart.order.orderRows.forEach((orderRow) => {
		if (orderRow.orderRowID === orderRowID) {
			orderRow.timeDeleted = moment().format();
		}
	});
	const updatedOrder = yield {...cart.order};
	const response = yield api.shop.updateOrder(cart.order.orderID, updatedOrder);
	yield put(updateOrderSuccess({
		orderID: response.data.data.order.orderID,
		order: response.data.data.order
	}));
}

export function* updateOrderSaga(action) {
	const { order, checkout } = action;
	const user = yield select(getUser);
	const partner = yield select(getPartner);
	const event = yield select(getEvent);
	const cart = {...yield select(getCart)};
	const partnerPortalSettings = yield select(getPartnerPortalSettings);
	let orderID = yield localStorage.getItem("orderID");
	let orderData = yield order;

	const userValues = { firstNames: user.data.firstNames, lastName: user.data.lastName, email: user.data.email };
	const orderUserValues = { firstNames: order.firstNames, lastName: order.lastName, email: order.email };
	const userValuesHasChanged = checkout ? (JSON.stringify(userValues) !== JSON.stringify(orderUserValues)) : false;
	const partnerBillingDetails = {
		invoiceCompany: partner.data.invoiceCompany,
		invoiceCompanyBusinessID: partner.data.invoiceCompanyBusinessID,
		invoiceStreetAddress: partner.data.invoiceStreetAddress,
		invoicePostalCode: partner.data.invoicePostalCode,
		invoiceCity: partner.data.invoiceCity,
		vatNumber: partner.data.vatNumber,
		eInvoiceAddress: partner.data.eInvoiceAddress,
		eInvoiceOperator: partner.data.eInvoiceOperator,
		eInvoiceIntermediateId: partner.data.eInvoiceIntermediateId
	};
	const orderBillingDetails = {
		invoiceCompany: order.invoiceCompany,
		invoiceCompanyBusinessID: order.invoiceCompanyBusinessID,
		invoiceStreetAddress: order.invoiceStreetAddress,
		invoicePostalCode: order.invoicePostalCode,
		invoiceCity: order.invoiceCity,
		vatNumber: order.vatNumber,
		eInvoiceAddress: order.eInvoiceAddress,
		eInvoiceOperator: order.eInvoiceOperator,
		eInvoiceIntermediateId: order.eInvoiceIntermediateId
	};
	const partnerValuesHasChanged = checkout ? (JSON.stringify(partnerBillingDetails) !== JSON.stringify(orderBillingDetails)) : false;

	if (!orderData.orderID){
		orderData = yield {
			/* firstNames: user.data.firstNames,
			lastName: user.data.lastName,
			company: user.data.company,
			city: user.data.city,
			countryCode: user.data.countryCode,
			postalCode: user.data.postalCode,
			email: user.data.email, */
			...(!partnerPortalSettings.userCanEditOrders ? {
				firstNames: user.data.firstNames,
				lastName: user.data.lastName,
				company: user.data.company,
				city: user.data.city,
				countryCode: user.data.countryCode,
				postalCode: user.data.postalCode,
				email: user.data.email,
			} : {}),
			partnerID: localStorage.getItem('partnerID') || null,
			organizationID: event.organizationID ? event.organizationID : localStorage.organizationID || null,
			eventID: event.eventID,
			...order,
			createdFrom: cart.order.createdFrom ? cart.order.createdFrom : 2,
		};
	};
	if(checkout) {
		orderData.orderRows = cart.order.orderRows ? [...cart.order.orderRows] :[];
		orderData.status = (partnerPortalSettings && partnerPortalSettings.userCanEditOrders) ? cart.order.status : 12;
	}

	let orderRows = checkout ? orderData.orderRows : action.order.orderRows;

	if(orderData.orderRows) {
		orderData.orderRows = yield [...orderRows.map(product => {
				product.productCount = product.productCount ? product.productCount : 1;
				return {
					orderID: orderID,
					productID: product.productID,
					orderRowID: product.orderRowID,
					price: product.price,
					name: product.name,
					description: product.description,
					originalPrice: product.price,
					taxPercent: product.taxPercent || "0",
					productCount:  parseInt(product.productCount, 2) !== 0 ? product.productCount : 1,/* (checkout ? cart.quantityById[product.productID] || 1 : product.productCount || 1) */
					productBundleID: product.productBundleID,
					createdFrom: 2,
					status: (checkout ? (product.status === 5 ? 3: product.status) : (product.status ? product.status : 5))
				}
			})
		];
	}

	orderData = yield {
		...orderData,
		paymentMethod: 1
	}
	try {
		/* const [
			userResponse,
			partnerResponse,
			orderResponse,
		] = yield all([
			...(userValuesHasChanged && !partnerPortalSettings.userCanEditOrders ? [yield api.user.saveUser(user.data.userID, orderUserValues)] : [yield null]),
			...(partnerValuesHasChanged ? [yield api.partner.savePartner(partner.data.partnerID, {...partner.data, ...orderBillingDetails })] : [yield null]),
			yield api.shop.updateOrder(orderID, orderData, action.eventID)
		]); */
		const orderResponse = yield api.shop.updateOrder(orderID, orderData, action.eventID);
		orderID = yield orderResponse.data.data.order.orderID;
		yield localStorage.setItem("orderID", orderID);
		yield put(updateOrderSuccess({orderID: orderID, order: orderResponse.data.data.order, checkoutSuccess: checkout }));
		
		if (checkout) {
			yield put(checkoutSuccess(orderID));
			if (!partnerPortalSettings.userCanEditOrders) {
				yield localStorage.removeItem("orderID");
			}
		}

	} catch (error) {
		// Can't create an order
		yield put(updateOrderFail(error));
	}
}
